import { useState } from 'react';
import { SnackBar } from '../../../components/snack-bar/SnackBar';
import { setOptOutCookie } from '../../../utilities/optout-cookie';
import { ANALYTICS_CONSTANTS, trackEDDL } from '../../../utilities/analytics';
import { ITrackingPayload } from '../../../types/analytics';

interface SnackBarProps {
    trigger: string;
    message: string;
}

const PrivacySnackBar = (props: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const snackBarMessage = 'Success! Your information is no longer being shared for value.';

    function handleClick() {
        const payload: ITrackingPayload = {
            event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
            linkDetails: {
                name: 'CLICK HERE FOR COOKIE OPT-OUT',
                position: 'OptOut',
            },
        };

        const track = new Promise((resolve) => {
            setTimeout(() => {
                resolve(trackEDDL(payload));
            }, 250);
        });

        track.then(() => {
            setOptOutCookie(() => setIsOpen(true));
        });
    }

    const onClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <button type="button" id="btn-opt-out-cookie" className="hm-btn--secondary" onClick={handleClick}>
                CLICK HERE FOR COOKIE OPT-OUT FOR SELLING AND FOR THE SHARING AND PROCESSING OF YOUR INFORMATION FOR
                TARGETED ADVERTISING
            </button>
            {isOpen && (
                <SnackBar textLabel={snackBarMessage} cancelAction={onClose} className={'privacy-policy-snackbar'} />
            )}
        </>
    );
};

export default PrivacySnackBar;
